<app-catalog-page-card title="SWAP PURPOSE SUBTYPE">
  <app-catalog-table-toolbar
    datatableId="kt_swap_purpose_subtype_datatable"
    searchPlaceholder="Search swap purpose subtype records..."
    addButtonLabel="Add Swap Purpose Subtype"
    addModalId="create_swap_purpose_subtype_modal"
    refreshAriaLabel="Refresh swap purpose subtypes"
    [disableRefresh]="isLoading()"
    (refresh)="loadRows()"
  ></app-catalog-table-toolbar>

  <app-catalog-crud-modal
    modalId="create_swap_purpose_subtype_modal"
    title="Create Swap Purpose Subtype"
    submitLabel="Create Swap Purpose Subtype"
    [submitting]="isCreating()"
    [formError]="createFormError()"
    (submit)="onCreate()"
    (cancel)="resetCreateForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="createForm">
        @if (lookupError()) {
          <div class="kt-alert kt-alert-destructive" role="alert">
            <div class="kt-alert-text">{{ lookupError() }}</div>
          </div>
        }

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-swap-purpose-subtype-name">
            Name <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="create-swap-purpose-subtype-name"
            type="text"
            class="kt-input"
            maxlength="30"
            formControlName="name"
            [attr.aria-invalid]="shouldShowCreateFieldError('name')"
          />

          @if (shouldShowCreateRequiredError('name')) {
            <div class="catalog-field-error">Name is required.</div>
          }

          @if (shouldShowCreateMaxLengthError('name')) {
            <div class="catalog-field-error">Name cannot exceed 30 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-swap-purpose-subtype-purpose">
            Purpose <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <select
            id="create-swap-purpose-subtype-purpose"
            class="kt-select"
            formControlName="purposeId"
            [attr.aria-invalid]="shouldShowCreateFieldError('purposeId')"
          >
            <option value="">Select purpose...</option>
            @for (item of purposes(); track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>

          @if (shouldShowCreateRequiredError('purposeId')) {
            <div class="catalog-field-error">Purpose is required.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="create-swap-purpose-subtype-description">Description</label>
          <input
            id="create-swap-purpose-subtype-description"
            type="text"
            class="kt-input"
            maxlength="50"
            formControlName="description"
            [attr.aria-invalid]="shouldShowCreateFieldError('description')"
          />

          @if (shouldShowCreateMaxLengthError('description')) {
            <div class="catalog-field-error">Description cannot exceed 50 characters.</div>
          }
        </div>
      </form>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#edit_swap_purpose_subtype_modal"
  ></button>

  <app-catalog-crud-modal
    modalId="edit_swap_purpose_subtype_modal"
    title="Edit Swap Purpose Subtype"
    submitLabel="Save Changes"
    [submitting]="isUpdating()"
    [formError]="editFormError()"
    (submit)="onUpdate()"
    (cancel)="resetEditForm()"
  >
    <div modal-body>
      <form class="grid gap-4" autocomplete="off" [formGroup]="editForm">
        @if (lookupError()) {
          <div class="kt-alert kt-alert-destructive" role="alert">
            <div class="kt-alert-text">{{ lookupError() }}</div>
          </div>
        }

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-swap-purpose-subtype-name">
            Name <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <input
            id="edit-swap-purpose-subtype-name"
            type="text"
            class="kt-input"
            maxlength="30"
            formControlName="name"
            [attr.aria-invalid]="shouldShowEditFieldError('name')"
          />

          @if (shouldShowEditRequiredError('name')) {
            <div class="catalog-field-error">Name is required.</div>
          }

          @if (shouldShowEditMaxLengthError('name')) {
            <div class="catalog-field-error">Name cannot exceed 30 characters.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-swap-purpose-subtype-purpose">
            Purpose <span class="catalog-required-marker" aria-hidden="true">*</span>
          </label>
          <select
            id="edit-swap-purpose-subtype-purpose"
            class="kt-select"
            formControlName="purposeId"
            [attr.aria-invalid]="shouldShowEditFieldError('purposeId')"
          >
            <option value="">Select purpose...</option>
            @for (item of purposes(); track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>

          @if (shouldShowEditRequiredError('purposeId')) {
            <div class="catalog-field-error">Purpose is required.</div>
          }
        </div>

        <div class="grid gap-1.5">
          <label class="kt-form-label" for="edit-swap-purpose-subtype-description">Description</label>
          <input
            id="edit-swap-purpose-subtype-description"
            type="text"
            class="kt-input"
            maxlength="50"
            formControlName="description"
            [attr.aria-invalid]="shouldShowEditFieldError('description')"
          />

          @if (shouldShowEditMaxLengthError('description')) {
            <div class="catalog-field-error">Description cannot exceed 50 characters.</div>
          }
        </div>
      </form>
    </div>
  </app-catalog-crud-modal>

  <button
    type="button"
    class="hidden"
    aria-hidden="true"
    tabindex="-1"
    data-kt-modal-toggle="#delete_swap_purpose_subtype_confirm_modal"
  ></button>

  <app-catalog-delete-confirm-modal
    modalId="delete_swap_purpose_subtype_confirm_modal"
    title="Remove Swap Purpose Subtype"
    message="Are you sure you want to remove this swap purpose subtype?"
    confirmLabel="Remove Swap Purpose Subtype"
    [confirming]="deletingId() !== null"
    (confirm)="confirmDelete()"
    (cancel)="cancelDelete()"
  ></app-catalog-delete-confirm-modal>

  @if (hasAlert()) {
    <div
      class="kt-alert kt-alert-light"
      [class.kt-alert-success]="alertVariant() === 'success'"
      [class.kt-alert-destructive]="alertVariant() === 'destructive'"
      role="alert"
    >
      <div class="kt-alert-icon">
        <i class="ki-filled ki-information" aria-hidden="true"></i>
      </div>

      <div class="grow">
        <div class="kt-alert-title"><strong>{{ alertTitle() }}</strong></div>

        @if (alertMessage()) {
          <div class="kt-alert-text">{{ alertMessage() }}</div>
        }
      </div>

      <div class="kt-alert-toolbar">
        <div class="kt-alert-actions">
          <button
            type="button"
            class="kt-alert-close"
            aria-label="Dismiss alert"
            (click)="dismissAlert()"
          >
            <i class="ki-filled ki-cross" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  }

  @if (isLoading()) {
    <div class="catalog-loading" role="status" aria-live="polite" aria-label="Loading swap purpose subtypes">
      <span class="catalog-loading-spinner" aria-hidden="true"></span>
      <span class="catalog-loading-text">Loading...</span>
    </div>
  }

  @if (!isLoading() && errorMessage()) {
    <div class="kt-alert kt-alert-destructive flex items-center justify-between gap-3">
      <span>{{ errorMessage() }}</span>
      <button type="button" class="kt-btn kt-btn-sm kt-btn-light" (click)="loadRows()">Retry</button>
    </div>
  }

  @if (!isLoading() && !errorMessage()) {
    <div
      id="kt_swap_purpose_subtype_datatable"
      class="kt-card-table"
      data-kt-datatable="true"
      data-kt-datatable-page-size="20"
      data-kt-datatable-state-save="true"
      data-kt-datatable-state-namespace="swap-purpose-subtype-datatable"
      (click)="onTableActionClick($event)"
    >
      <div class="kt-table-wrapper kt-scrollable">
        <table class="kt-table" data-kt-datatable-table="true">
          <thead>
            <tr>
              <th scope="col" data-kt-datatable-column="name">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Name</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th scope="col" data-kt-datatable-column="purpose">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Purpose</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th scope="col" data-kt-datatable-column="description">
                <span class="kt-table-col">
                  <span class="kt-table-col-label">Description</span>
                  <span class="kt-table-col-sort"></span>
                </span>
              </th>
              <th
                scope="col"
                data-kt-datatable-column="actions"
                data-kt-datatable-column-sort="false"
                class="text-end"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            @if (rows().length === 0) {
              <tr>
                <td colspan="4" class="text-center text-secondary-foreground py-6">
                  No swap purpose subtypes found.
                </td>
              </tr>
            } @else {
              @for (item of rows(); track item.id) {
                <tr>
                  <td>{{ item.name }}</td>
                  <td>{{ item.purposeName || '-' }}</td>
                  <td>{{ item.description || '-' }}</td>
                  <td class="text-end">
                    <span class="inline-flex gap-2.5">
                      <button
                        type="button"
                        class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                        aria-label="Edit swap purpose subtype"
                        data-action="edit-swap-purpose-subtype"
                        [attr.data-swap-purpose-subtype-id]="item.id"
                        [disabled]="deletingId() !== null || isUpdating()"
                      >
                        <i class="ki-filled ki-pencil" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        class="kt-btn kt-btn-sm kt-btn-icon kt-btn-outline"
                        aria-label="Remove swap purpose subtype"
                        data-action="delete-swap-purpose-subtype"
                        [attr.data-swap-purpose-subtype-id]="item.id"
                        [disabled]="deletingId() !== null"
                      >
                        <i class="ki-filled ki-trash" aria-hidden="true"></i>
                      </button>
                    </span>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="flex items-center justify-between gap-4 flex-wrap px-5 py-4">
        <div data-kt-datatable-info="true" class="kt-datatable-info text-sm text-secondary-foreground"></div>

        <div class="kt-datatable-length flex items-center gap-3">
          <select data-kt-datatable-size="true" class="kt-select kt-select-sm w-20"></select>
          <div data-kt-datatable-pagination="true" class="kt-datatable-pagination flex items-center gap-2"></div>
        </div>
      </div>
    </div>
  }
</app-catalog-page-card>


